<template>
  <div class="full-height">
    <amf-form class="container">
      <div class="d-flex flex-row">
        <amf-select
          class="p-2"
          label="Filters"
          caption="-- All --"
          :options="filterOptions"
          v-model="selectedFilter"
          :show-label="false"
        ></amf-select>
        <amf-button
          class="m-3 btn-success"
          label="test"
          :onClick="clearFilter"
          v-if="selectedFilter != null"
          title="Clear selection"
          :show-label="false"
          >X Clear</amf-button
        >
      </div>

      <div v-if="busy">Loading...</div>

      <div v-if="!busy && dailyEntries.length == 0">No records.</div>

      <div class="row form-group" v-else>
        <table
          class="table table-hover table-bordered table-sm mt-3 table-accounts"
        >
          <thead>
            <th>Created Date</th>
            <th>Employer Name</th>
            <th>Deposit Amount</th>
            <th>Deposit Status</th>
            <th></th>
          </thead>
          <tbody v-for="n in dailyEntries" :key="n.id">
            <tr
              @click="(x) => toggleRow(n.bankTransferId)"
              title="Click row to expand or collapse details"
            >
              <td>{{ $formatters.date(n.createdDate) }}</td>
              <td>{{ n.employerName }}</td>
              <td>${{ n.total }}</td>
              <td>
                <span v-if="n.processingStatus > 5">
                  <i class="fa fa-check-circle" style="color: green"></i>
                </span>
                <span v-else-if="n.processingStatus == 5">
                  <i class="fa fa-times-circle" style="color: red"></i>
                </span>
                <span v-else>
                  <i class="fa fa-minus-circle" style="color: orange"></i>
                </span>
              </td>
              <td><i class="fa fa-chevron-down" /></td>
            </tr>
            <tr
              class="hideRow"
              v-bind:name="n.bankTransferId"
              style="background-color: grey"
            >
              <td colspan="9" style="padding: 0">
                <hsaPushDetail
                  :bankTransferId="n.bankTransferId"
                  :closeEditor="toggleRow"
                ></hsaPushDetail>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </amf-form>
  </div>
</template>

<script>
import HsaPushDetail from "./HsaPushDetail";
import $ from "jquery";

export default {
  props: [{ type: Object }],
  components: {
    HsaPushDetail,
  },
  data() {
    return {
      selectedFilter: 1,
      filterOptions: [
        { id: 1, name: "Pending" },
        { id: 2, name: "Rejected" },
        { id: 3, name: "Confirmed" },
      ],
      amfOptions: { noTracking: true },
    };
  },
  computed: {
    ...amfx.map("nachas", ["hsaPushBankTransfers"]),
    payType() {
      return this.$route.params.payType;
    },
    dailyEntries() {
      switch (this.selectedFilter) {
        case 1:
          return this.hsaPushBankTransfers.filter(
            (x) => x.processingStatus < 5
          );
        case 2:
          return this.hsaPushBankTransfers.filter(
            (x) => x.processingStatus == 5
          );
        case 3:
          return this.hsaPushBankTransfers.filter(
            (x) => x.processingStatus >= 6
          );
        default:
          return this.hsaPushBankTransfers;
      }
    },
  },
  methods: {
    ...amfx.map("nachas", ["loadHsaPushBankTransfers"]),
    async load() {
      this.busy = true;

      await this.loadHsaPushBankTransfers();

      this.busy = false;
    },

    openEntryDetail(bankTransferId) {
      this.$router.push({
        path: `/nacha/hsapushdetail/${bankTransferId}`,
      });
    },
    toggleRow(bankTransferId) {
      let elem = $("tr[name=" + bankTransferId + "]").toggle();
      let row = elem.prev().children().last().empty();
      row.append(
        "<i class='fa fa-chevron-" +
          (elem.is(":visible") ? "up" : "down") +
          "' />"
      );
    },
    clearFilter() {
      this.selectedFilter = null;
    },
  },
  created() {
    this.load();
  },
  watch: {
    payType(newValue) {
      if (!newValue) return;
      this.load();
    },
  },
};
</script>

<style lang="scss" scoped>
.nacha-list {
  height: 100%;
  overflow-y: scroll;
  a {
    color: black;
  }
}
.hideRow {
  display: none;
}
.tran-action {
  margin: 0 5px;
}
.table-accounts {
  th {
    text-align: center;
    padding: 6px;
    background-color: #e5e5e5;
    border: 0px;
    border-top: 1px solid #eaeaea;
    border-bottom: 1px solid #eaeaea;
  }
  td {
    text-align: center;
    padding: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/finance/HsaPushList.vue